window.fisherAnalytics = window.fisherAnalytics || {};
window.fisherAnalytics.myListObserver = (function() {
    // All constants, variables, and functions are now scoped inside this IIFE
    let debounceTimeout;
    let partNumber;
    let myListTabName;
    const selectorsToWatch = [
        '.js-ut-add-to-list',
        '.pdp_family_my_list',
        '#SKUHighlightContainer .add_to_list_pdp>a',
        '.add-to-hotlist-main span',
        '.mylist_dropdown_li_item',
        '.btnQuickFavorite',
        '#tabCreateList span',
        '#tabAddToList span',
        '.mylist_overlay_create_list_button',
        '.divFavoritesWrapper .addCommentRemoveItemFavorite span:first-child',
        '.divFavoritesWrapper .addCommentRemoveItem span:last-child',
        '[aria-label="Remove"]',
        '#myListAppTabsId li a span',
        '#createListModalId a.p-tabview-nav-link .p-tabview-title',
        '#createListModalId .inline_button_list button span',
        '.headerButtonsContainer a p',
        '#shareListModalId .p-button-label',
        '#shareListModalButton span',
        '.top-purchases .addCommentRemoveItem.addCommentRemoveItemFavorite span',
        '.divContentClass .addCommentRemoveItem span:last-child',
        '.directoryWrapper p.titleToLeft',
        '[id^="favorite-item-"]',
        '#reorder_modal_add_to_list',
        '.headerItem.addItemToListButton'
    ];
    const urlPatterns = [
        '/store1/cart/',
        '/browse/',
        '/catalog/search/',
        '/catalog/featured/',
        '/special-offers-and-programs/',
        '/store1/mylist',
        '/shop/products/',
        '/store1/orders'
    ];
    const selectorsConfig = {
        '.js-ut-add-to-list': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '#reorder_modal_add_to_list': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '.headerItem.addItemToListButton': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '.pdp_family_my_list': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '#SKUHighlightContainer .add_to_list_pdp>a': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '.add-to-hotlist-main span': {
            method: [window.fisherAnalytics.utils.addEvents],
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '.mylist_dropdown_li_item' : {
            description: 'Dropdown items in Add to List modal, will be used to get list name',
            method: [window.fisherAnalytics.utils.addEvents],
            parent: 'Add to List',
            text: 'List Selected',
            eventName : 'addToList',
            eventType: 'click',
            listenerCallback: [setListName]
        },
        '.btnQuickFavorite': {
            method: [window.fisherAnalytics.utils.addEvents],
            parent: 'Add to List',
            text: 'Quick Add to Favorites List',
            eventName : 'addToFavorites',
            eventType: 'click',
            listenerCallback: dispatchListProductEvent
        },
        '[id^="favorite-item-"]':{
            method: [window.fisherAnalytics.utils.addEvents],
            parent: 'Add to Favorites',
            text: 'Add to Favorites Icon',
            eventName : 'addToFavorites',
            eventType: 'click',
            useTargetClassname: 'fav-empty-heart',
            listenerCallback: [setDetails, dispatchListProductEvent]
        },
        '#tabAddToList span' : {
            method: [addAnalyticsAttributes],
            parent: 'Add to List',
            text: 'Add to List'
        },
        '#tabCreateList span' : {
            method: [addAnalyticsAttributes],
            parent: 'Create New List',
            text: 'Create New List'
        },
        '.mylist_overlay_create_list_button' : {
            method: [window.fisherAnalytics.utils.addEvents],
            parent: 'Add to List',
            text: 'Create List',
            eventName : 'createNewList',
            eventType: 'click'
        },
        '.divFavoritesWrapper .addCommentRemoveItemFavorite span:first-child':{
            method: [window.fisherAnalytics.utils.addEvents,addAnalyticsAttributes],
            container: 'Favorites',
            parent: 'Product',
            additionalAttributes: {'data-common-label': 'Favorites'},
            text: 'Add to List',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '.divFavoritesWrapper .addCommentRemoveItem span:last-child':{
            method: [addAnalyticsAttributes,window.fisherAnalytics.utils.addEvents,setTabName],
            container: getActiveTabName,
            parent: 'Product',
            text: 'Remove',
            eventName : 'removeLink',
            eventType: 'click',
            listenerCallback: getPartNumber
        },
        '[aria-label="Remove"]' : {
            method: [addAnalyticsAttributes],
            description: 'Remove button from modal',
            container: 'Favorites',
            parent: 'Product',
            text: 'Remove Item'
        },
        '#myListAppTabsId li a span' : {
            method: [addAnalyticsAttributes,window.fisherAnalytics.utils.addEvents],
            description: 'Main tabs on My List page',
            emptyContainer: true,
            parent: 'List Tab',
            useElementText: true,
            eventName : 'myListTabClick',
            eventType: 'click',
            listenerCallback: [myListTabClick]
        },
        '#createListModalId a.p-tabview-nav-link .p-tabview-title' : {
            method: [addAnalyticsAttributes],
            description: 'Create list modal buttons',
            container: getActiveTabName,
            useElementText: true,
            parent: 'Create List',
            elementTextSelector: null

        },
        '#createListModalId .inline_button_list button span' : {
            method: [addAnalyticsAttributes],
            description: 'Create list button in modal',
            container: getActiveTabName,
            useElementText: true,
            parent: 'Create List',
            elementTextSelector: null
        },
        '#shareListModalId .p-button-label': {
            method: [addAnalyticsAttributes],
            description: 'Accept buttons in modal',
            container: getActiveTabName,
            useElementText: true,
            parent: 'Share with Others',
            elementTextSelector: null
        },
        '.headerButtonsContainer a p' : {
            method: [addAnalyticsAttributes],
            description: 'Create / Accept Buttons ',
            container: getActiveTabName,
            useElementText: true,
            parentSameAsText: true,
            elementTextSelector: null
        },
        '#shareListModalButton span' : {
            method: [addAnalyticsAttributes],
            description: 'Share List Button',
            container: getActiveTabName,
            parent: 'Share with Others',
            text: 'Share with Others'
        },
        '.top-purchases .addCommentRemoveItem.addCommentRemoveItemFavorite span' : {
            method: [addAnalyticsAttributes, window.fisherAnalytics.utils.addEvents],
            description: 'Add to List links for Top Purchase',
            container: getActiveTabName,
            additionalAttributes: {'data-common-label': 'Top Purchases'},
            parent: 'Product',
            text: 'Add to List',
            eventName : 'addToListOpened',
            eventType: 'click',
            listenerCallback: [setDetails]
        },
        '.divContentClass .addCommentRemoveItem span:last-child': {
            method: [window.fisherAnalytics.utils.addEvents,setTabName],
            description: 'Remove links for Personal and Company sections',
            container: getActiveTabName,
            parent: 'Product',
            text: 'Remove',
            eventName : 'removeItemFromList',
            eventType: 'click',
            listenerCallback: [setDetails,setListName]
        },
        '.directoryWrapper p.titleToLeft' : {
            method: [addAnalyticsAttributes],
            section: 'My List',
            container: getActiveTabName,
            parent: 'Select List',
            useElementText: true
        }
    }
    //We already have explicit site sections for PDP pages (Item and Family)
    const siteSectionsConfig = {
        '/store1/cart/': {
            siteSection: 'Checkout',
            container: 'Shopping Cart',
            parent: 'Saved for Later'
        },
        '/catalog/search/': {
            siteSection: 'Search',
            container: 'Pricing and Availability',
            parent: 'Search Results'
        },
        '/catalog/featured/': {
            siteSection: 'Featured',
            container: 'Pricing and Availability',
            parent: 'Catalog Featured Results'
        },
        '/browse/': {
            siteSection: 'Browse',
            container: 'Pricing and Availability',
            parent : 'Browse Results'
        },
        '/special-offers-and-programs/':{
            siteSection: 'Special Offers and Programs',
            container: 'Pricing and Availability',
            parent: 'Qualifying Products'
        },
        '/store1/mylist':{
            siteSection: 'My List',
            container: 'My List'
        },
        '/shop/products/':{
            siteSection: 'PDP',
            container: digitalData.page.type
        },
        '/store1/orders':{
            siteSection: 'Order Status',
            container: 'Order Details'
        },
        '/store1/orders/details/':{
            siteSection: 'Order Status',
            container: 'Reorder Modal'
        }

    }

    function debounceInit() {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            window.fisherAnalytics.utils.initModules(selectorsToWatch, selectorsConfig);
        }, 100); // Adjust the delay as needed
    }

    function addAnalyticsAttributes(element, selectorName) {
        let siteSection;
        let container = 'Shopping Cart';
        let parent = 'Saved for Later';
        let analyticsText = selectorsConfig[selectorName].text || 'Add to List';
        let additionalAttributes = selectorsConfig[selectorName].additionalAttributes || {};

        if (!element || !(element instanceof Element)) {
            console.error('Invalid DOM element provided.');
            return;
        }

        siteSection = selectorsConfig[selectorName].siteSection || getSiteSection();
        container = selectorsConfig[selectorName].container || getContainer();
        parent = selectorsConfig[selectorName].parent || getParent();

        //We can override the text and use the element text instead
        if(selectorsConfig[selectorName].useElementText){
            if(element.querySelector(selectorsConfig[selectorName].elementTextSelector)){
                analyticsText = element.querySelector(selectorsConfig[selectorName].elementTextSelector).textContent.replace(/\s*\(.*$/, '');
            } else {
                analyticsText = element.textContent.replace(/\s*\(.*$/, '');
            }

        }

        //In some cases we want the parent and the text to be the same
        if(selectorsConfig[selectorName].parentSameAsText){
            parent = analyticsText;
        }

        //In some instances, the container value will be a function
        if(typeof container === 'function'){
            container = container();
        }

        //Container can be emptyContainer
        if(selectorsConfig[selectorName].emptyContainer){
            container='';
        }

        //analyticsText can be a function
        if(typeof analyticsText === 'function'){
            analyticsText = analyticsText();
        }

        //Update all data attributes for analytics
        element.setAttribute('data-analytics-section', siteSection);
        element.setAttribute('data-analytics-container', container);
        element.setAttribute('data-analytics-parent', parent);
        element.setAttribute('data-analytics-text', analyticsText);

        // Add any additional analytics attributes if present
        if (additionalAttributes && typeof additionalAttributes === 'object') {
            Object.keys(additionalAttributes).forEach(function(attrKey) {
                if (additionalAttributes[attrKey] !== undefined && additionalAttributes[attrKey] !== null) {
                    element.setAttribute(attrKey, additionalAttributes[attrKey]);
                }
            });
        }
    }
    function dispatchListEvent(e){
        var element = e.currentTarget;
        let useTargetClassname = element.dataset.useTargetClassname || null;
        var eventName = element.dataset.eventName;
        var partNumberArray = typeof partNumbers !== 'undefined' ? partNumbers[0] : [];
        var productType = env.userIsPunchOut ? 'punchout' : 'regular item';

        //If this is a special case like favorites where we have to check the target classname
        if(useTargetClassname && !e.target.classList.contains(useTargetClassname)){
            return null;
        }

        //For capturing the part number during a Remove, we have to find the parent element
        if(partNumberArray.length === 0 && typeof partNumber !=='undefined'){
            partNumberArray['partNumber'] = partNumber;
        }


        document.dispatchEvent(new CustomEvent(eventName, {'productSKU': partNumberArray['partNumber'],'productType': productType}));
    }
    function dispatchListProductEvent(e){
        var element = e.currentTarget;
        let useTargetClassname = element.dataset.useTargetClassname || null;
        var eventName = element.dataset.eventName;
        let data = env.temporaryDetails || {};
        //If this is a special case like favorites where we have to check the target classname
        if(useTargetClassname && !e.target.classList.contains(useTargetClassname)){
            return null;
        }
        document.dispatchEvent(new CustomEvent(eventName, data));
    }

    function setListName(e){
        let el = e ? e.currentTarget : null;
        let listName;
        if(digitalData.page.type === "My List"){
            if(el && el.getAttribute('data-iteminlist')){
                listName = el.textContent;
            } else {
                if(document.querySelector('.myListHeaderTitle')){
                    listName = document.querySelector('.myListHeaderTitle').textContent;
                }
            }
        } else {
            if(el){
                listName = el.textContent.replace(/\s*\(.*$/, '').replace(/\s+/g, '');
            }
        }

        if(env.temporaryDetails && env.temporaryDetails.detail){
            if(env.temporaryDetails.detail.list){
                env.temporaryDetails.detail.list.name = listName;
            } else {
                env.temporaryDetails.detail.list = {
                    name: listName
                }
            }
        }
    }

    function extractGlyphValues(container, imgSelector = 'img') {
        const glyphsSet = new Set();
        const allImages = container.querySelectorAll(imgSelector);
        Array.from(allImages).forEach(img => {
            if (img.src && img.src.includes('glyph')) {
                if (img.alt) {
                    glyphsSet.add(img.alt.toLowerCase());
                }
            }
        });
        return Array.from(glyphsSet);
    }

    function setDetails(e) {
        try {
            let productTitleText = '';
            let isSearch = document.querySelectorAll('.search_result_item').length > 0;
            let isPDFP = false;
            let isCart = document.querySelectorAll('.cart-ui-product-table').length > 0;
            let isMyList = digitalData.page.type === "My List";
            let isMyListFavorites = false;
            let isMyListTopPurchases = false;
            let isReorder = location.pathname.indexOf('/store1/orders/details/') > -1;
            let isOrderDetails = location.pathname.indexOf('/store1/orders?') > -1;
            let el = e.currentTarget, container, familyId, partNumber, productTitle, glyphValues = [], price = 0.00,
                variation, details, priceContainer, priceStringContainer,priceHasMultiple = false, checkedRadioButton, priceString,
                label,priceElement, variationStrings;
            let useTargetClassname = el.dataset.useTargetClassname || null;
            let quickViewRowContainer = {};
            let euPrice = function(rawPrice) {
                // --- Extract currency symbol (optional) ---
                try {
                    const currencyMatch = rawPrice.match(/[€£₤₺₦₽₾₿₸₴₹₫₭₮₩¥₦₡₲₱₵₳₢₣₧₰₯₠]/);
                    const currency = currencyMatch ? currencyMatch[0] : null;

                    // --- Extract numeric part ---
                    const numericPartMatch = rawPrice.match(/[\d.,]+/);
                    if (!numericPartMatch) {
                        console.warn('No numeric value found');
                    } else {
                        let numericPart = numericPartMatch[0];

                        // Detect which character is used as the decimal separator
                        // If both '.' and ',' exist, assume the rightmost one is the decimal
                        const lastDot = numericPart.lastIndexOf('.');
                        const lastComma = numericPart.lastIndexOf(',');
                        const decimalSeparator = lastComma > lastDot ? ',' : '.';

                        // Remove all thousands separators
                        if (decimalSeparator === ',') {
                            numericPart = numericPart.replace(/\./g, ''); // remove dots as thousands sep
                            numericPart = numericPart.replace(',', '.'); // replace comma with dot
                        } else {
                            numericPart = numericPart.replace(/,/g, ''); // remove commas as thousands sep
                        }

                        // Convert to number
                        console.log('Currency:', currency);
                        console.log('Price:', price);

                        if (numericPart) {
                            return parseFloat(numericPart);
                        }
                    }
                } catch (e) {
                    window.fisherAnalytics.utils.logError("Issue converting EU price in mylist-observer" + e);
                }
            }
            if (typeof env === 'undefined') {
                // If 'env' is not defined, initialize it
                let env = window.env || {};
                delete env.temporaryDetails;
            }
            //is this a PDP page?
            if (digitalData.page && digitalData.page.type) {
                isPDFP = digitalData.page.type.indexOf('Product:Family') > -1;
            }
            if (!isSearch && !isPDFP && !isCart && !isMyList && !isReorder) {
                let rootKey = Object.keys(digitalData.products.primary);
                if (rootKey[0].length > 0) {
                    env.temporaryDetails = {
                        detail: {
                            products: [
                                {
                                    discount: digitalData.products.primary[rootKey].discount,
                                    familyId: digitalData.products.primary[rootKey].familyId,
                                    name: digitalData.products.primary[rootKey].name,
                                    price: digitalData.products.primary[rootKey].price,
                                    sku: digitalData.products.primary[rootKey].sku,
                                    variation: digitalData.products.primary[rootKey].variation,
                                    type: digitalData.page.type,
                                    badges: digitalData.products.primary[rootKey].badges,
                                    glyphs: digitalData.products.primary[rootKey].glyphs
                                }
                            ]
                        }
                    }
                }
                return;
            }

            if(isReorder){
                container =  el && el.closest ? el.closest('#reorderItemModal') : null;
                if (!container) {
                    return null;
                }

                if(container.querySelector('.partNumber')){
                    partNumber = container.querySelector('.partNumber').textContent.replace(/[^a-zA-Z0-9-]/g, '');
                }

                if(container.querySelector('.partTitle')){
                    productTitle = container.querySelector('.partTitle').textContent;
                }

                priceContainer = container.querySelector('.priceDiv');

                if(priceContainer){
                    priceHasMultiple = priceContainer.querySelector('input[type="radio"]');
                    if(priceHasMultiple){
                        // Find the checked radio button within the container
                        checkedRadioButton = priceContainer.querySelector('input[name="uom_select"]:checked');

                        // Check if a checked radio button is found
                        if (checkedRadioButton) {
                            priceString = priceDiv.textContent;
                            let priceMatch = priceString.match(/\$\d+\.\d{2}/);
                            if(priceMatch && priceMatch.length > 0){
                                price = parseFloat(priceMatch[0].textContent.replace(/[^\d.-]/g, ''));
                            }

                            //get pack variation
                            const radioButtons = priceContainer.querySelectorAll('input[name="uom_select"]');
                            let selectedIndex = -1;
                            radioButtons.forEach((radioButton, index) => {
                                if (radioButton.checked) {
                                    selectedIndex = index;
                                }
                            });
                            // Split the text content by line breaks to get individual lines
                            const lines = priceDivText.split('\n').map(line => line.trim()).filter(line => line);

                            // Extract the pack size text based on the selected index
                            const priceAndPackSize = lines[selectedIndex * 2 + 1]; // Each radio button has two lines associated with it

                            // Use a regular expression to find the pack size
                            const packSizeMatch = priceAndPackSize.match(/\/ .+/);
                            variation = packSizeMatch ? packSizeMatch[0] : null;
                        } else {
                            console.log('No checked radio button found.');
                        }
                    } else {
                        //TODO handle single price scenario
                    }
                }

                details = {
                    detail: {
                        products: [
                            {
                                discount: "",
                                familyId: partNumber,
                                name: productTitle,
                                price: price,
                                sku: partNumber,
                                variation: variation,
                                type: digitalData.page.type,
                                badges: [],
                                glyphs: glyphValues
                            }
                        ]
                    }
                }
                env.temporaryDetails = details;
            }


            if (isSearch) {
                container = el && el.closest ? el.parentNode.closest('.search_result_item.displayToggleControlled') : null;
                if(useTargetClassname && !e.target.classList.contains(useTargetClassname)){
                    return null;
                }
                if (!container) {
                    return null;
                }
                quickViewRowContainer = container.querySelector('.qvBodyWrapper');
                familyId = 'p-' + container.getAttribute('data-familyid');
                partNumber = el.closest('div').getAttribute('data-partnumber');
                productTitle = container.querySelector('.result_title a').textContent;
                glyphValues = extractGlyphValues(quickViewRowContainer ? quickViewRowContainer : container);

                //get price when there's more than one
                price = 0.00;
                if (quickViewRowContainer.querySelectorAll('[type=radio]:checked').length > 0) {
                    price = parseFloat(quickViewRowContainer.querySelectorAll('[type=radio]:checked')[0].closest('.uom-container').querySelector('.qvui_gds_qv_itemPrice').textContent.replace(/[^\d.-]/g, ''));

                    variation = quickViewRowContainer.querySelectorAll('[type=radio]:checked')[0].closest('.uom-container').querySelector('.qvui_gds_qv_displayUnitString').textContent
                } else if (quickViewRowContainer.querySelectorAll('.qvui_gds_qv_itemPrice')[0]) {
                    price = parseFloat(quickViewRowContainer.querySelectorAll('.qvui_gds_qv_itemPrice')[0].textContent.replace(/[^\d.-]/g, ''));
                    variation = quickViewRowContainer.querySelector('.uom-container').querySelector('.qvui_gds_qv_displayUnitString ').textContent;
                }
                details = {
                    detail: {
                        products: [
                            {
                                discount: "",
                                familyId: familyId,
                                name: productTitle,
                                price: price,
                                sku: partNumber,
                                variation: variation,
                                type: digitalData.page.type,
                                badges: [],
                                glyphs: glyphValues
                            }
                        ]
                    }
                }
                env.temporaryDetails = details;
            }
            //For Family pages (most have been migrated to chip view, but not all in EU PROD)
            if (isPDFP) {
                container = el.closest('tbody');
                if(useTargetClassname && !e.target.classList.contains(useTargetClassname)){
                    return null;
                }
                familyId = document.querySelector('#familyPart').value;
                partNumber = container.getAttribute('data-row-partnumber');
                let productTitleTextElement = container.querySelector('.manufacturer_name');
                let nonChipViewTitleElement = document.querySelector('#qa_product_description');

                if(!productTitleTextElement && nonChipViewTitleElement){
                    productTitleText = nonChipViewTitleElement.textContent || 'No Product Title Found';
                } else if(nonChipViewTitleElement){
                    productTitleText =  nonChipViewTitleElement.textContent || 'No Product Title Found';
                } else {
                    productTitleText = 'No Product Title Found';
                }

                glyphValues = extractGlyphValues(container);

                //get price when there's more than one
                price = 0.00;
                if (container.querySelectorAll('[type=radio]:checked').length > 0) {
                    price = parseFloat(container.querySelectorAll('[type=radio]:checked')[0].closest('.product_add_to_cart').querySelector('.click_uom_sec').querySelector('[data-pirce-uom]').textContent.replace(/[^\d.-]/g, ''));
                    variation = container.querySelectorAll('[type=radio]:checked')[0].getAttribute('data-uom-value');
                } else if (container.querySelectorAll('.qvui_gds_qv_itemPrice')[0]) {
                    price = parseFloat(container.querySelectorAll('.qvui_gds_qv_itemPrice')[0].textContent.replace(/[^\d.-]/g, ''));
                    variation = "PK";
                } else if (container.querySelector('.ind_price_in_pt')) {
                    //EU has no radios
                    let rawText = container.querySelector('.ind_price_in_pt');
                    let rawPrice;
                    if(rawText){
                        rawPrice =
                            rawText
                                .querySelector('span')
                                .textContent
                                .trim();
                    }
                    price = euPrice(rawPrice);
                }
                details = {
                    detail: {
                        products: [
                            {
                                discount: "",
                                familyId: familyId,
                                name: productTitleText.replace(/\s+/g, " ").replace(/^\s+|\s+$/g, ""),
                                price: price,
                                sku: partNumber,
                                variation: variation,
                                type: digitalData.page.type,
                                badges: [],
                                glyphs: glyphValues
                            }
                        ]
                    }
                }
                env.temporaryDetails = details;
            }

            //For Cart page
            if (isCart) {
                container = el && el.closest ? el.closest('.cart-ui-product-table') : null;

                if (!container) {
                    return null;
                }
                variation = container.querySelector('.display-unit-string-display.secondary-text').textContent;
                //familyId = document.querySelector('#familyPart').value;
                partNumber = el.getAttribute('data-partnumber');
                let productTitleText = el.getAttribute('data-shortdesc');

                glyphValues = extractGlyphValues(container);

                //get price when there's more than one
                price = parseFloat(container.querySelector('.price-display.primary-text').textContent.replace(/[^\d.-]/g, ''));

                details = {
                    detail: {
                        products: [
                            {
                                discount: "",
                                familyId: partNumber,
                                name: productTitleText,
                                price: price,
                                sku: partNumber,
                                variation: variation,
                                type: digitalData.page.type,
                                badges: [],
                                glyphs: glyphValues
                            }
                        ]
                    }
                }
                env.temporaryDetails = details;

            }
            //My List has 3 different ways to show products.
            if(isMyList) {
                container = el && el.closest ? el.closest('.itemRowDiv') : null;

                //Test for Top Purchases / Favorites section
                if(el.hasAttribute('data-common-label') && el.getAttribute('data-common-label') === 'Top Purchases'){
                    container = el && el.closest ? el.closest('[id^="item-"]') : null;
                    isMyListTopPurchases = true;
                }

                if(el.hasAttribute('data-common-label') && el.getAttribute('data-common-label') === 'Favorites'){
                    container = el && el.closest ? el.closest('.itemRowDiv') : null;
                    isMyListFavorites = true;
                }

                if (!container) {
                    return null;
                }

                priceContainer = container.querySelector('.uomPrice');
                priceString = '0.00'
                priceHasMultiple = false;

                if(priceContainer){
                    priceHasMultiple = priceContainer.querySelector('input[type="radio"]');
                    priceStringContainer = priceContainer.querySelector('div').querySelector('span');
                    if(priceStringContainer){
                        priceString = priceStringContainer.textContent;
                    }
                    if(priceHasMultiple){
                        priceContainer = container.querySelector('.itemUomDiv');

                        if(isMyListTopPurchases){
                            priceContainer = container.querySelector('.itemUom');
                        }
                        // Find the checked radio button within the container
                        const checkedRadioButton = priceContainer.querySelector('.p-radiobutton-checked input[type="radio"]:checked');

                        // Check if a checked radio button is found
                        if (checkedRadioButton) {
                            // Find the corresponding label for the checked radio button
                            label = priceContainer.querySelector(`label[for="${checkedRadioButton.id}"]`);

                            // Check if the label exists
                            if (label) {
                                if(isMyListTopPurchases){
                                    priceElement = label.querySelector('span');
                                } else {
                                    // Find the <p> tag that contains the price within the label
                                    priceElement = label.querySelector('p');
                                }

                                // Check if the price element exists and get its text content
                                if (priceElement) {
                                    priceString = priceElement.textContent;
                                    console.log('Selected Price:', priceString);
                                } else {
                                    console.log('Price element not found.');
                                }
                            } else {
                                console.log('Label for the checked radio button not found.');
                            }
                        } else {
                            console.log('No checked radio button found.');
                        }
                    }
                    variationStrings = priceContainer.querySelectorAll('.pDisplayUnitString');

                    if(variationStrings && variationStrings.length > 0){
                        variation = variationStrings[variationStrings.length - 1].textContent;
                    }
                }

                //familyId = document.querySelector('#familyPart').value;
                if(isMyListTopPurchases){
                    partNumber = container.getAttribute('id').replace('item-','')
                } else {
                    partNumber = container.firstChild.getAttribute('id').replace('item-','')
                }

                let productTitleText = container.querySelector('.itemTitle').textContent;

                glyphValues = extractGlyphValues(container);

                //get price when there's more than one
                price = priceString ? parseFloat(priceString.replace(/[^\d.-]/g, '')) : 0.00;

                details = {
                    detail: {
                        products: [
                            {
                                discount: "",
                                familyId: partNumber,
                                name: productTitleText,
                                price: price,
                                sku: partNumber,
                                variation: variation,
                                type: digitalData.page.type,
                                badges: [],
                                glyphs: glyphValues
                            }
                        ]
                    }
                }
                env.temporaryDetails = details;
            }
        }catch (e){
            window.fisherAnalytics.utils.log("Issue with setDetails() in mylist-observer: " + e);
            console.error(e.message)
            }
    }

    function getPartNumber(element,selectorName){
        var partNumberElement = element.currentTarget.closest('[id^="item-"]');
        if(partNumberElement){
            partNumber = partNumberElement.getAttribute('id').split('-')[1]
        }
    }
    function myListTabClick(e){
        if(typeof window.digitalDataManager.setPageName === 'function'){
            window.digitalDataManager.setPageName("My Lists:" + e.currentTarget.textContent.replace(/\s*\(.*$/, ''));
        }
    }
    function getActiveTabName(){
        let tabs = document.querySelectorAll('#myListAppTabsId li');
        let currentTabLabel;
        if(tabs){
            for (let index = 0; index < tabs.length; index++) {
                const li = tabs[index];
                if (li.classList.contains('p-highlight')) {
                    currentTabLabel = li.querySelector('a span').textContent.replace(/\s*\(.*$/, '');
                    break;
                }
            }
            return currentTabLabel;
        }
    }
    function setTabName(){
        myListTabName = getActiveTabName();
    }

    function getSiteSection() {
        for (let i = 0; i < urlPatterns.length; i++) {
            const urlPattern = urlPatterns[i];
            if (document.location.href.indexOf(urlPattern) > 0) {
                return siteSectionsConfig[urlPattern].siteSection;
            }
        }
        try{
            return window.digitalData.page.type;
        }catch(e){
            window.fisherAnalytics.utils.log("issue with getSiteSection() in mylist-observer: " + e);
            console.error(e.message)
        }
    }

    function getContainer() {
        for (let i = 0; i < urlPatterns.length; i++) {
            const urlPattern = urlPatterns[i];
            if (document.location.href.indexOf(urlPattern) > 0) {
                return siteSectionsConfig[urlPattern].container;
            }
        }
        try{
            return window.digitalData.page.type;
        }catch(e){
            window.fisherAnalytics.utils.log("issue with getContainer() in mylist-observer " + e);
            console.error(e.message)
        }
    }

    function getParent() {
        for (let i = 0; i < urlPatterns.length; i++) {
            const urlPattern = urlPatterns[i];
            if (document.location.href.indexOf(urlPattern) > 0) {
                return siteSectionsConfig[urlPattern].parent;
            }
        }
        try{
            return window.digitalData.page.type;
        }catch(e){
            window.fisherAnalytics.utils.log("issue with getParent() in mylist-observer " + e);
            console.error(e.message)
        }
    }

    //call digitalData method to set page name based on tab
    function setPageName(){
        if(typeof digitalDataManager.setPageName === 'function'){
            digitalDataManager.setPageName("My Lists:" + getActiveTabName());
        }
    }

    // ---- helpers ----
    function throttle(fn, wait) {
        let last = 0, timeout = null, pendingArgs = null, pendingThis = null;
        return function throttled(...args) {
            const now = Date.now();
            const remaining = wait - (now - last);
            pendingArgs = args; pendingThis = this;
            if (remaining <= 0) {
                if (timeout) { clearTimeout(timeout); timeout = null; }
                last = now;
                fn.apply(pendingThis, pendingArgs);
                pendingArgs = pendingThis = null;
            } else if (!timeout) {
                timeout = setTimeout(() => {
                    last = Date.now();
                    fn.apply(pendingThis, pendingArgs);
                    pendingArgs = pendingThis = null;
                    timeout = null;
                }, remaining);
            }
        };
    }

    // Expose only what you want public
    return {
        debounceInit,
        addAnalyticsAttributes,
        dispatchListEvent,
        getPartNumber,
        getActiveTabName,
        setTabName,
        getSiteSection,
        getContainer,
        getParent,
        urlPatterns,
        setDetails,
        setListName,
        selectorsToWatch,
        selectorsConfig,
        throttle
    };
})();

// Set up a MutationObserver to call debounceInit() whenever the DOM changes
/*const mylistObserver = new MutationObserver((mutationsList, observer) => {
    window.fisherAnalytics.myListObserver.debounceInit();
});

// Define the target node and mylistObserver options
const targetNode = document.body;
const observerOptions = {
    childList: true, // Observe direct children
    subtree: true,   // Observe all descendants
    attributes: false, // Do not observe attribute changes
    characterData: false // Do not observe character data changes
};

// Only run mylistObserver and init if the current URL matches one of the patterns
const shouldRunMyListObserver = window.fisherAnalytics.myListObserver.urlPatterns.some(pattern => window.location.pathname.includes(pattern));

if (shouldRunMyListObserver) {
    // Start observing the target node for configured mutations
    mylistObserver.observe(targetNode, observerOptions);
    // Initial call to init() to handle any elements already present in the DOM
    window.fisherAnalytics.utils.initModules(window.fisherAnalytics.myListObserver.selectorsToWatch, window.fisherAnalytics.myListObserver.selectorsConfig);
}*/

const targetNode = document.body; // Prefer a narrower container if possible
const observerOptions = {
    childList: true,
    subtree: true,
    // keep attributes/characterData false unless you truly need them
};

// URL gate (pathname-based)
const { myListObserver } = window.fisherAnalytics;
const shouldRun = myListObserver.urlPatterns.some(p => window.location.pathname.includes(p));
const runInit = () => window.fisherAnalytics.utils.initModules(myListObserver.selectorsToWatch, myListObserver.selectorsConfig);

// Throttled runner with disconnect/reconnect to avoid feedback loops
const observer = new MutationObserver(() => throttledRun());
const throttledRun = myListObserver.throttle(() => {
    // Temporarily stop listening while we mutate
    observer.disconnect();
    try {
        runInit();
    } finally {
        // Re-attach after a short pause to let synchronous mutations settle
        setTimeout(() => observer.observe(targetNode, observerOptions), 150);
    }
}, 300); // tweak: 200–500ms is a good starting range

if (shouldRun) {
    observer.observe(targetNode, observerOptions);
    // Fire once for existing DOM
    runInit();
}